import { Result } from '@coveo/headless';
import cn from 'classnames';

import { useCoveoResult } from 'src/hooks/useCoveoResult';

import { hasValue } from 'src/utils/hasValue';

import Date from 'components/BaseHelpers/Date';

import LinkOrComponent from '../LinkOrComponent/LinkOrComponent';

import styles from './BaseSearchResults.module.scss';

export const BaseSearchResult = ({ result }: { result: Result; showImages?: boolean }) => {
  const { data, logResultAnalytics } = useCoveoResult({ result });
  const { type, title, titleOverride, date, displayDate, url, excerpt } = data;

  return (
    <LinkOrComponent
      field={url}
      className={styles['result-link']}
      onClick={url ? logResultAnalytics : undefined}
    >
      <div className={styles['content']}>
        {(type || date) && (
          <div className={styles['content-type-and-date']}>
            {type && <span className={styles['content-type']}>{type}</span>}
            {(date !== undefined || displayDate !== undefined) && (
              <Date field={date} displayDate={displayDate} />
            )}
          </div>
        )}

        <h3
          className={cn(styles['title'], { [styles['title--override']]: hasValue(titleOverride) })}
          dangerouslySetInnerHTML={{ __html: hasValue(titleOverride) ? titleOverride : title }}
        ></h3>
        {excerpt && (
          <span className={styles['exerpt']} dangerouslySetInnerHTML={{ __html: excerpt }}></span>
        )}
      </div>
    </LinkOrComponent>
  );
};
